module.exports = __webpack_public_path__ + "media/images/Splash-iconsize-c0759d965897be9407f91a46f0794362.png";